<template>
    <div class="major-analysis-container">
        <div class="card-container" v-if="Status.LoadingCompleted">
            <!-- 筛选区 -->
            <div class="search-box">
                <el-select v-model="filterForm.cc" multiple placeholder="全部层次" style="width: 200px;" clearable>
                    <el-option v-for="item in ccOptions" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-select v-model="filterForm.pc" multiple placeholder="全部批次" style="width: 200px;" clearable>
                    <el-option v-for="item in pcOptions" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-button type="primary" @click="loadData" :loading="loading">查询</el-button>
                <el-button @click="resetFilter">重置</el-button>
            </div>

            <!-- 全国录取情况分析 -->
            <div class="section-block">
                <h3 class="section-title">全国录取情况分析</h3>
                <p v-html="analysisText"></p>
            </div>

            <!-- 直方图 -->
            <div class="section-block">
                <div class="chart-wrapper">
                    <div class="chart-controls">
                        <el-radio-group v-model="chartDisplayMode" @change="generateBarChart" size="small">
                            <el-radio-button label="top10">显示前十</el-radio-button>
                            <el-radio-button label="bottom10">显示后十</el-radio-button>
                            <el-radio-button label="all">显示全部</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div class="chart-controls-right">
                        <el-button size="mini" icon="el-icon-download" @click="downloadBar">下载图片</el-button>
                    </div>
                    <v-chart ref="barChart" :option="barOption" style="height: 350px;" autoresize></v-chart>
                </div>
            </div>

            <!-- 专业详情表格 -->
            <div class="section-block">
                <div class="section-header">
                    <h3 class="section-title">专业详情</h3>
                    <el-button type="success" size="small" icon="el-icon-download" @click="handleExport">导出</el-button>
                </div>
                <div class="data-table-wrapper">
                    <div class="data-table-body">
                        <el-table :data="tableData" border :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight: '600'}">
                            <el-table-column type="index" label="序号" min-width="60" align="center"></el-table-column>
                            <el-table-column prop="MajorName" label="专业名称" min-width="200" align="center"></el-table-column>
                            <el-table-column prop="College" label="学院" min-width="150" align="center" :filters="collegeFilters" :filter-method="filterCollege"></el-table-column>
                            <el-table-column prop="TotalCount" label="录取数" min-width="100" align="center"></el-table-column>
                            
                            <!-- 性别 -->
                            <el-table-column label="性别" align="center">
                                <el-table-column prop="MaleCount" label="男" min-width="80" align="center"></el-table-column>
                                <el-table-column prop="FemaleCount" label="女" min-width="80" align="center"></el-table-column>
                            </el-table-column>
                            
                            <!-- 调剂率 -->
                            <el-table-column label="调剂率" align="center">
                                <el-table-column prop="TransferCount" label="调剂数" min-width="90" align="center"></el-table-column>
                                <el-table-column prop="TransferRate" label="调剂率" min-width="90" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row.TransferRate ? scope.row.TransferRate.toFixed(2) + '%' : '-' }}
                                    </template>
                                </el-table-column>
                            </el-table-column>
                            
                            <!-- 第X志愿率(1-20) -->
                            <el-table-column v-for="i in 20" :key="'v' + i" :label="'第' + convertToChineseNumber(i) + '志愿率'" align="center">
                                <el-table-column :label="'志愿数'" min-width="80" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row['Volunteer' + i + 'Count'] || 0 }}
                                    </template>
                                </el-table-column>
                                <el-table-column :label="'志愿率'" min-width="80" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row['Volunteer' + i + 'Rate'] ? scope.row['Volunteer' + i + 'Rate'].toFixed(2) + '%' : '-' }}
                                    </template>
                                </el-table-column>
                            </el-table-column>
                            
                            <!-- 详细信息 -->
                            <el-table-column label="详细信息" min-width="120" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="showProvinceDetail(scope.row)">查看招生省份</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>

        <!-- 招生省份详情弹窗 -->
        <el-dialog :title="'专业：' + currentMajor.MajorName + ' - 招生省份详情'" :visible.sync="provinceDialogVisible" width="90%" top="5vh">
            <div class="province-detail-container">
                <div class="section-header">
                    <h3></h3>
                    <el-button type="success" size="small" icon="el-icon-download" @click="handleExportProvince">导出</el-button>
                </div>
                <el-table :data="provinceTableData" border style="width: 100%" :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight: '600'}" max-height="500px">
                    <el-table-column type="index" label="序号" min-width="60" align="center" fixed></el-table-column>
                    <el-table-column prop="Province" label="省份" min-width="120" align="center" fixed></el-table-column>
                    <el-table-column prop="Kl" label="科类" min-width="100" align="center" :filters="klFilters" :filter-method="filterKl"></el-table-column>
                    <el-table-column prop="Pc" label="批次" min-width="120" align="center" :filters="pcFilters" :filter-method="filterPc"></el-table-column>
                    <el-table-column prop="Cc" label="层次" min-width="100" align="center" :filters="ccFilters" :filter-method="filterCc"></el-table-column>
                    <el-table-column prop="TotalCount" label="录取数" min-width="100" align="center"></el-table-column>
                    <el-table-column prop="ControlLine" label="省控线" min-width="100" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.ControlLine || '-' }}
                        </template>
                    </el-table-column>
                    
                    <!-- 性别 -->
                    <el-table-column label="性别" align="center">
                        <el-table-column prop="MaleCount" label="男" min-width="80" align="center"></el-table-column>
                        <el-table-column prop="FemaleCount" label="女" min-width="80" align="center"></el-table-column>
                    </el-table-column>
                    
                    <!-- 调剂率 -->
                    <el-table-column label="调剂率" align="center">
                        <el-table-column prop="TransferCount" label="调剂数" min-width="90" align="center"></el-table-column>
                        <el-table-column prop="TransferRate" label="调剂率" min-width="90" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.TransferRate ? scope.row.TransferRate.toFixed(2) + '%' : '-' }}
                            </template>
                        </el-table-column>
                    </el-table-column>
                    
                    <!-- 第一志愿率 -->
                    <el-table-column label="第一志愿率" align="center">
                        <el-table-column prop="Volunteer1Count" label="志愿数" min-width="90" align="center"></el-table-column>
                        <el-table-column prop="Volunteer1Rate" label="志愿率" min-width="90" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.Volunteer1Rate ? scope.row.Volunteer1Rate.toFixed(2) + '%' : '-' }}
                            </template>
                        </el-table-column>
                    </el-table-column>
                    
                    <!-- 分数 -->
                    <el-table-column label="分数" align="center">
                        <el-table-column prop="MaxScore" label="最高分" min-width="90" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.MaxScore ? scope.row.MaxScore.toFixed(1) : '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="MinScore" label="最低分" min-width="90" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.MinScore ? scope.row.MinScore.toFixed(1) : '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="AvgScore" label="平均分" min-width="90" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.AvgScore ? scope.row.AvgScore.toFixed(1) : '-' }}
                            </template>
                        </el-table-column>
                    </el-table-column>
                    
                    <!-- 分差 -->
                    <el-table-column prop="ScoreDiff" label="分差" min-width="90" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.ScoreDiff ? scope.row.ScoreDiff.toFixed(1) : '-' }}
                        </template>
                    </el-table-column>
                    
                    <!-- 线差情况 -->
                    <el-table-column label="线差情况" align="center">
                        <el-table-column prop="MaxLineDiff" label="最高分线差" min-width="110" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.MaxLineDiff ? scope.row.MaxLineDiff.toFixed(1) : '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="MinLineDiff" label="最低分线差" min-width="110" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.MinLineDiff ? scope.row.MinLineDiff.toFixed(1) : '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="AvgLineDiff" label="平均分线差" min-width="110" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.AvgLineDiff ? scope.row.AvgLineDiff.toFixed(1) : '-' }}
                            </template>
                        </el-table-column>
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { TYBM_Env } from '../../env.js';
import { TYBM_Tools } from '../../tools.js';
import VChart from 'vue-echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';

export default {
    name: 'MajorAnalysis',
    components: {
        VChart
    },
    inject: ['Loading', 'LoadingCompleted'],
    data() {
        return {
            Status: {
                LoadingCompleted: false
            },
            loading: false,
            filterForm: {
                cc: [],
                pc: []
            },
            ccOptions: [],
            pcOptions: [],
            tableData: [],
            analysisText: '',
            schoolName: '',
            year: 0,
            totalCount: 0,
            chartDisplayMode: 'top10',
            barOption: {},
            collegeFilters: [],
            provinceDialogVisible: false,
            currentMajor: {},
            provinceTableData: [],
            klFilters: [],
            pcFilters: [],
            ccFilters: []
        };
    },
    methods: {
        convertToChineseNumber(num) {
            const chineseNumbers = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十',
                                   '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十'];
            return chineseNumbers[num - 1] || num;
        },
        loadFilters() {
            const that = this;
            const api_name = '/Analysis/GetMajorFilters';
            const url = TYBM_Env.GetApiUrl(api_name);

            TYBM_Tools.AxiosGetEx(that, api_name, url, { loading: false })
                .then(result => {
                    that.ccOptions = result.data.CcOptions;
                    that.pcOptions = result.data.PcOptions;
                });
        },
        loadData() {
            const that = this;
            that.loading = true;

            const api_name = '/Analysis/GetMajorData';
            let url = TYBM_Env.GetApiUrl(api_name);

            // 添加筛选参数
            const params = [];
            if (that.filterForm.cc && that.filterForm.cc.length > 0) {
                params.push('CC=' + encodeURIComponent(that.filterForm.cc.join(',')));
            }
            if (that.filterForm.pc && that.filterForm.pc.length > 0) {
                params.push('PC=' + encodeURIComponent(that.filterForm.pc.join(',')));
            }
            if (params.length > 0) {
                url += '?' + params.join('&');
            }

            TYBM_Tools.AxiosGetEx(that, api_name, url, { loading_msg: '正在加载数据' })
                .then(result => {
                    that.tableData = result.data.StatList;
                    that.totalCount = result.data.TotalCount;
                    that.schoolName = result.data.SchoolName;
                    that.year = result.data.Year;

                    // 如果是首次加载，获取筛选选项
                    if (that.ccOptions.length === 0) {
                        that.loadFilters();
                    }

                    // 生成学院筛选器
                    that.collegeFilters = [...new Set(that.tableData.map(item => item.College).filter(c => c))].map(c => ({ text: c, value: c }));

                    // 生成分析文字
                    that.generateAnalysisText();

                    // 生成图表
                    that.generateBarChart();

                    that.Status.LoadingCompleted = true;
                })
                .catch(() => {
                    that.$message.error('加载数据失败');
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        resetFilter() {
            this.filterForm.cc = [];
            this.filterForm.pc = [];
            this.loadData();
        },
        generateAnalysisText() {
            const that = this;
            if (!that.tableData || that.tableData.length === 0) {
                that.analysisText = '';
                return;
            }

            // 录取前十的专业
            const top10 = that.tableData.slice(0, 10);
            const top10Text = top10.map(item => {
                const ratio = (item.TotalCount / that.totalCount * 100).toFixed(2);
                return `${item.MajorName}(${item.TotalCount}人，${ratio}%)`;
            }).join('、');

            that.analysisText = `${that.schoolName}${that.year}年共录取${that.totalCount}人 ，录取前十的专业为${top10Text}。`;
        },
        generateBarChart() {
            const that = this;
            let filteredData = [];

            if (that.chartDisplayMode === 'top10') {
                filteredData = that.tableData.slice(0, 10);
            } else if (that.chartDisplayMode === 'bottom10') {
                filteredData = that.tableData.slice(-10);
            } else {
                filteredData = that.tableData;
            }

            const majors = filteredData.map(item => item.MajorName);
            const counts = filteredData.map(item => item.TotalCount);

            that.barOption = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '15%',
                    top: '5%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: majors,
                    axisLabel: {
                        interval: 0,
                        rotate: 0,
                        fontSize: 12
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        type: 'bar',
                        data: counts,
                        barMaxWidth: 40,
                        itemStyle: {
                            color: '#409EFF'
                        },
                        label: {
                            show: true,
                            position: 'top',
                            fontSize: 10
                        }
                    }
                ]
            };
        },
        downloadBar() {
            const chart = this.$refs.barChart;
            if (chart) {
                const url = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff'
                });
                const link = document.createElement('a');
                link.download = `各专业录取人数直方图_${this.year}.png`;
                link.href = url;
                link.click();
            }
        },
        filterCollege(value, row) {
            return row.College === value;
        },
        filterKl(value, row) {
            return row.Kl === value;
        },
        filterPc(value, row) {
            return row.Pc === value;
        },
        filterCc(value, row) {
            return row.Cc === value;
        },
        showProvinceDetail(row) {
            const that = this;
            that.currentMajor = row;
            that.provinceDialogVisible = true;

            // 加载该专业的省份详情
            const api_name = '/Analysis/GetMajorProvinceDetail';
            let url = TYBM_Env.GetApiUrl(api_name);
            url += '?MajorCode=' + encodeURIComponent(row.MajorCode);

            TYBM_Tools.AxiosGetEx(that, api_name, url, { loading_msg: '正在加载省份详情' })
                .then(result => {
                    that.provinceTableData = result.data.ProvinceList;
                    
                    // 生成筛选器
                    that.klFilters = [...new Set(that.provinceTableData.map(item => item.Kl).filter(k => k))].map(k => ({ text: k, value: k }));
                    that.pcFilters = [...new Set(that.provinceTableData.map(item => item.Pc).filter(p => p))].map(p => ({ text: p, value: p }));
                    that.ccFilters = [...new Set(that.provinceTableData.map(item => item.Cc).filter(c => c))].map(c => ({ text: c, value: c }));
                })
                .catch(() => {
                    that.$message.error('加载省份详情失败');
                });
        },
        handleExport() {
            const that = this;
            if (that.tableData.length === 0) {
                that.$message.warning('没有数据可导出');
                return;
            }

            let csvContent = "\uFEFF";

            // 表头
            const headers = ["序号", "专业名称", "学院", "录取数", "男", "女", "调剂数", "调剂率"];
            for (let i = 1; i <= 20; i++) {
                headers.push(`第${that.convertToChineseNumber(i)}志愿数`);
                headers.push(`第${that.convertToChineseNumber(i)}志愿率`);
            }
            csvContent += headers.join(",") + "\n";

            // 数据行
            that.tableData.forEach((row, index) => {
                const rowData = [
                    index + 1,
                    row.MajorName,
                    row.College || '-',
                    row.TotalCount,
                    row.MaleCount || 0,
                    row.FemaleCount || 0,
                    row.TransferCount || 0,
                    row.TransferRate ? row.TransferRate.toFixed(2) + '%' : '-'
                ];
                for (let i = 1; i <= 20; i++) {
                    rowData.push(row['Volunteer' + i + 'Count'] || 0);
                    rowData.push(row['Volunteer' + i + 'Rate'] ? row['Volunteer' + i + 'Rate'].toFixed(2) + '%' : '-');
                }
                csvContent += rowData.join(",") + "\n";
            });

            // 下载
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", `专业详情_${that.year}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        handleExportProvince() {
            const that = this;
            if (that.provinceTableData.length === 0) {
                that.$message.warning('没有数据可导出');
                return;
            }

            let csvContent = "\uFEFF";

            // 表头
            const headers = ["序号", "省份", "科类", "批次", "层次", "录取数", "省控线", "男", "女", 
                            "调剂数", "调剂率", "第一志愿数", "第一志愿率",
                            "最高分", "最低分", "平均分", "分差",
                            "最高分线差", "最低分线差", "平均分线差"];
            csvContent += headers.join(",") + "\n";

            // 数据行
            that.provinceTableData.forEach((row, index) => {
                const rowData = [
                    index + 1,
                    row.Province,
                    row.Kl,
                    row.Pc,
                    row.Cc,
                    row.TotalCount,
                    row.ControlLine || '-',
                    row.MaleCount || 0,
                    row.FemaleCount || 0,
                    row.TransferCount || 0,
                    row.TransferRate ? row.TransferRate.toFixed(2) + '%' : '-',
                    row.Volunteer1Count || 0,
                    row.Volunteer1Rate ? row.Volunteer1Rate.toFixed(2) + '%' : '-',
                    row.MaxScore ? row.MaxScore.toFixed(1) : '-',
                    row.MinScore ? row.MinScore.toFixed(1) : '-',
                    row.AvgScore ? row.AvgScore.toFixed(1) : '-',
                    row.ScoreDiff ? row.ScoreDiff.toFixed(1) : '-',
                    row.MaxLineDiff ? row.MaxLineDiff.toFixed(1) : '-',
                    row.MinLineDiff ? row.MinLineDiff.toFixed(1) : '-',
                    row.AvgLineDiff ? row.AvgLineDiff.toFixed(1) : '-'
                ];
                csvContent += rowData.join(",") + "\n";
            });

            // 下载
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", `${that.currentMajor.MajorName}_招生省份详情_${that.year}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    },
    created() {
        this.loadData();
    },
    mounted() {
        // 监听年份变化
        this.$root.$on('global-year-change', this.loadData);
    },
    beforeDestroy() {
        this.$root.$off('global-year-change', this.loadData);
    }
};
</script>

<style scoped>
.major-analysis-container {
    width: 100%;
}

.search-box {
    display: flex;
    gap: 12px;
    margin-bottom: 15px;
    align-items: center;
}

.section-block {
    margin-bottom: 0px;
    background: white;
    border-radius: 8px;
    padding: 5px;
}

.section-title {
    margin: 0 0 12px 0;
    color: #303133;
    font-size: 16px;
    font-weight: 600;
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
}

    .chart-wrapper {
        position: relative;
        margin-top: 40px;
    }

.chart-controls {
    position: absolute;
    left: 10px;
    top: -30px;
    z-index: 10;
    display: flex;
    gap: 10px;
    align-items: center;
}

    .chart-controls-right {
        position: absolute;
        right: 10px;
        top: -30px;
        z-index: 10;
        display: flex;
        gap: 10px;
        align-items: center;
    }

.data-table-wrapper {
    background: white;
    border-radius: 8px;
    overflow-x: auto;
    overflow-y: auto;
    max-height: calc(100vh - 520px);
}

.data-table-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.data-table-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 5px;
}

.data-table-wrapper::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 5px;
}

.data-table-wrapper::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.data-table-body {
    width: max-content;
    min-width: 100%;
}

.data-table-body >>> .el-table {
    font-size: 13px;
}

.data-table-body >>> .el-table th,
.data-table-body >>> .el-table td {
    padding: 8px 0 !important;
}

.data-table-body >>> .el-table th {
    background-color: #f5f7fa !important;
    color: #606266;
    font-weight: 600;
}

.data-table-body >>> .el-table__row:hover {
    background-color: #f5f9ff;
}

.data-table-body >>> .el-table .cell {
    padding: 0 8px;
}

.province-detail-container {
    margin-top: -15px;
}
</style>
